module.exports = __webpack_public_path__ + "img/Slider-AUTO_en.07c83a37.png";